import React, { useCallback } from 'react'
import { useTranslation } from 'react-i18next'
import { Button, Card, Flex, Typography } from 'antd'
import backgroundImage from 'src/assets/images/background-page.png'
import bfaLogo from 'src/assets/images/bfa-logo.png'
import DangerAlert from 'src/assets/images/danger-alert.png'
import { colorBgBrandless, colorTextSubtlest } from 'src/app/themes/primaryThemeDefault'
import { useNavigate } from 'react-router-dom'
import { menuUrls } from '../../constants/menu.constants'
import { useRolePermission } from '../../hooks/useRolePermission'
import { USER_ROLE } from '../../constants/app.constants'
import './logout.scss'

const AccessDenied: React.FC = () => {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const { role } = useRolePermission()

  const handleGoBack = useCallback(() => {
    if (!!role && role === USER_ROLE.IT_SYSTEM_ADMIN) {
      navigate(menuUrls.helpPageManagement)
    } else {
      navigate(menuUrls.home)
    }
  }, [navigate, role])

  return (
    <div
      className='page-container'
      style={{
        backgroundImage: `url(${backgroundImage})`,
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        position: 'relative',
      }}
    >
      <img src={bfaLogo} alt='page-logo' className='page-logo' />

      <Card className='page-card' bordered={false} style={{ paddingTop: 0 }}>
        <Flex gap={32} vertical>
          <Flex align='center' justify='center' vertical>
            <img src={DangerAlert} alt='access_denied_logo' height={40} width={40} style={{ marginBottom: 0 }} />
            <Typography.Title style={{ lineHeight: '38px', fontSize: '28px', margin: 0 }}>
              {t('common:accessDeniedOops')}
            </Typography.Title>
          </Flex>
          <Flex
            align='center'
            vertical
            style={{ background: colorBgBrandless, borderRadius: 16, padding: '12px 16px' }}
          >
            <Typography.Title level={1} style={{ lineHeight: '30px', fontSize: '22px' }}>
              {t('common:accessDenied')}
            </Typography.Title>

            <Typography.Text
              type='secondary'
              style={{
                textAlign: 'center',
                color: colorTextSubtlest,
                lineHeight: '22px',
                fontSize: '16px',
              }}
            >
              {t('common:accessDeniedMessage')}
            </Typography.Text>
          </Flex>

          <Button size='large' style={{ fontWeight: 700 }} block className='btn-back' ghost onClick={handleGoBack}>
            {t('common:backToHome')}
          </Button>
        </Flex>
      </Card>
    </div>
  )
}

export default AccessDenied
